import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Card, WarningCallout } from "nhsuk-react-components";
import { login } from "../actions/userActions";
import BrowserCheck from "../components/browserCheck/BrowserCheck";

function PatientLoginScreen({ history, location }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loginError, setLoginError] = useState(null);
    const [captcha, setCaptcha] = useState("");

    const dispatch = useDispatch();
    const redirect = location.search ? location.search.split("=")[1] : "/";
    const userLogin = useSelector((state) => state.userLogin);
    const { loading, success, error, userInfo } = userLogin;

    useEffect(() => {
        document.title = "Patient login - MyHeartPassport";
    }, []);

    useEffect(() => {
        if (userInfo && success) {
            if (userInfo.requiresTwoFactor) {
                history.push("/2fauth");
            } else {
                history.push(redirect ? redirect : "/");
            }
        }
    }, [userInfo, success, history, redirect]);

    useEffect(() => {
        if (error) setLoginError(error);
    }, [error]);

    const submitHandler = (e) => {
        e.preventDefault();
        setLoginError(null);
        if (!captcha) {
            setLoginError("Wait for the browser check to finish.");
            return;
        }
        dispatch(login(email, password, captcha));
    };

    return (
        <div className="nhsuk-width-container">
            <main className="nhsuk-main-wrapper" id="maincontent" role="main">
                <div className="nhsuk-grid-row">
                    <div className="nhsuk-grid-column-two-thirds auth-card" style={{ margin: "0 auto", float: "none" }}>
                        <Card>
                            <Card.Content>
                                <header className="auth-card__header">
                                    <span className="nhsuk-caption-l">MyHeartPassport</span>
                                    <h1 className="nhsuk-heading-l">Patient login</h1>
                                    <p className="nhsuk-body auth-card__lede">
                                        Sign in with the email and password you registered with.
                                    </p>
                                </header>

                                {loginError && (
                                    <div className="nhsuk-error-summary" aria-labelledby="patient-login-error" role="alert" tabIndex="-1">
                                        <h2 className="nhsuk-error-summary__title" id="patient-login-error">There is a problem</h2>
                                        <div className="nhsuk-error-summary__body">
                                            <ul className="nhsuk-list nhsuk-error-summary__list">
                                                <li>{loginError}</li>
                                            </ul>
                                        </div>
                                    </div>
                                )}

                                <form onSubmit={submitHandler}>
                                    <div className="nhsuk-form-group">
                                        <label className="nhsuk-label" htmlFor="patient-email">Email</label>
                                        <input className="nhsuk-input" id="patient-email" type="email" value={email} required onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                    <div className="nhsuk-form-group">
                                        <label className="nhsuk-label" htmlFor="patient-password">Password</label>
                                        <input className="nhsuk-input" id="patient-password" type="password" value={password} required onChange={(e) => setPassword(e.target.value)} />
                                    </div>

                                    <BrowserCheck onToken={setCaptcha} />

                                    <button className="nhsuk-button" type="submit" style={{ width: "100%" }} disabled={loading || !captcha}>
                                        {loading ? "Signing in…" : "Sign in"}
                                    </button>
                                </form>

                                <WarningCallout>
                                    <WarningCallout.Label>Need help?</WarningCallout.Label>
                                    <p>If you can't sign in, contact the team that looks after your heart device.</p>
                                </WarningCallout>

                                <p>
                                    <Link className="nhsuk-link" to={redirect ? `/resetpasswordsetup?redirect=${redirect}` : "/resetpasswordsetup"}>Forgotten password?</Link>
                                </p>
                                <p>
                                    New here? <Link className="nhsuk-link" to={redirect ? `/register-patient?redirect=${redirect}` : "/register-patient"}>Create a patient account</Link>
                                </p>
                                <p>
                                    <Link className="nhsuk-link" to="/login">Staff sign in</Link>
                                </p>
                            </Card.Content>
                        </Card>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default PatientLoginScreen;
